/**
 * Sentry initialisation for Hyring Platform frontend (React + Vite).
 * Must be imported FIRST in src/main.jsx, before React.
 */
import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN
const environment =
  import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development'
const release = import.meta.env.VITE_SENTRY_RELEASE || 'dev'

if (!dsn) {
  console.warn('[sentry] VITE_SENTRY_DSN not set — error reporting disabled')
} else {
  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ??
        (environment === 'production' ? 0.1 : 1.0)
    ),
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^\/api\//,
      /^https:\/\/platform\.hyring\.ai\/api\//,
      /^http:\/\/172\.104\.156\.251:3002\/api\//,
    ],
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /extension\//i,
      /^chrome:\/\//i,
    ],
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.Authorization
        delete event.request.headers.Cookie
      }
      return event
    },
  })
  console.log(`[sentry] initialised — env=${environment} release=${release}`)
}

export { Sentry }
